import React, { createContext, useContext, useState } from 'react';

interface HubAuthContextType {
  token: string | null;
  isAuthenticated: boolean;
  login: (token: string) => void;
  logout: () => void;
}

const HubAuthContext = createContext<HubAuthContextType | null>(null);

export const HubAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('hub_token'));

  const login = (newToken: string) => {
    localStorage.setItem('hub_token', newToken);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem('hub_token');
    setToken(null);
  };

  return (
    <HubAuthContext.Provider value={{ token, isAuthenticated: !!token, login, logout }}>
      {children}
    </HubAuthContext.Provider>
  );
};

export const useHubAuth = () => {
  const ctx = useContext(HubAuthContext);
  if (!ctx) throw new Error('useHubAuth must be used within HubAuthProvider');
  return ctx;
};
